
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { LanguageSelector } from '../common/LanguageSelector';

export function LandingHeader() {
  const navigate = useNavigate();

  const handleSignInClick = () => {
    navigate('/login');
  };

  return (
    <header className="fixed w-full bg-white/80 backdrop-blur-md border-b border-gray-100 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
            <div className="h-10 w-10 bg-gradient-to-br from-green-600 to-blue-600 rounded-lg flex items-center justify-center shadow-lg">
              <Check className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-blue-600">
              HALMAS
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-gray-600 hover:text-green-600 font-medium transition-colors">
              Features
            </a>
            <a href="#benefits" className="text-gray-600 hover:text-green-600 font-medium transition-colors">
              Benefits
            </a>
            <a href="#about" className="text-gray-600 hover:text-green-600 font-medium transition-colors">
              About
            </a>
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-4">
            <div className="hidden sm:block">
              <LanguageSelector />
            </div>
            
            <button
              onClick={handleSignInClick}
              className="text-gray-600 hover:text-green-600 font-medium px-4 py-2 transition-colors"
            >
              Sign In
            </button>
            <button
              onClick={() => navigate('/register')} // Placeholder route
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 rounded-full font-medium transition-all shadow-lg hover:shadow-green-200"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
